import costCenters from './costCenters'
import countries from './countries'
import departmentSearch from './departmentSearch'
import employeeTypes from './employeeTypes'
import employeeTitles from './employeeTitles'
import globalMapObjects from './globalMapObjects'
import geoLocations from './geoLocations'
import regions from './regions'
import spaceTypes from './spaceTypes'
import usageTypes from './usageTypes'
import buildings from './buildings'
import spaceTagSearch from './spaceTagSearch'
import settings from './settings'
import buildingTypes from './buildingTypes'
import name from './name'
import asset from './asset'
import locations from './locations'
import locationCapacities from './locationCapacities'
import locationHealthChecks from './locationHealthChecks'
import locationBookableDesks from './locationBookableDesks'
import fetchAssetTags from './assetTags'
import fetchWorkPlaceGroups from './workplaceGroups'
import fetchCalendars from './calendars'
import emailAlias from './emailAlias'

export default {
  asset,
  costCenters,
  countries,
  departmentSearch,
  employeeTypes,
  globalMapObjects,
  geoLocations,
  regions,
  spaceTypes,
  usageTypes,
  buildings,
  spaceTagSearch,
  settings,
  buildingTypes,
  employeeTitles,
  name,
  locations,
  locationCapacities,
  locationHealthChecks,
  locationBookableDesks,
  fetchAssetTags,
  fetchWorkPlaceGroups,
  fetchCalendars,
  emailAlias,
}
